;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { useMedia } from 'react-use';

import cx from 'clsx';

import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import styles from './TalesBlockTwoImage.module.scss';

const TalesBlockTwoImage = ({ images = [], border = true, isActive }) => {
    const rootRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    const isMedium = useMedia('(min-width: 768px)', false);

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: isMedium ? 0.5 : 0,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
        }

        if (!isActive) {
            setIsInView(false);
        }
    }, [intersection, isActive]);

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.border]: border,
                [styles.isInView]: isInView,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.media}>
                    {images?.map((image, index) => (
                        <div key={index} className={styles.mediaItem}>
                            <Img
                                className={styles.image}
                                src={image.url}
                                width={image?.width}
                                height={image?.height}
                                alt={image.description}
                                customSources={[
                                    {
                                        breakpoint: 768,
                                        src: image.url,
                                        imageWidth: 1920,
                                    },
                                    {
                                        src: image.url,
                                        imageWidth: 1280,
                                    },
                                ]}
                            />
                            {image.description && (
                                <Text
                                    baseTheme="bodyXSmall"
                                    className={styles.caption}
                                >
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: image.description,
                                        }}
                                    />
                                </Text>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TalesBlockTwoImage;
